import {OktaAuth, toRelativeUrl} from '@okta/okta-auth-js'
import appConfig from '@/config'
import {scopes, storageKeys} from '@dxp-common-components-updated/config-global/okta.config'
import router from '@/router'

const oktaConfig = {scopes, storageKeys}

let oktaAuth: OktaAuth | Record<string, never> = {}

if (import.meta.env.VITE_OFFLINE !== 'true') {
  const customAuthUrl = `${appConfig.oktaHostedUrl}/oauth2/${appConfig.authorizationServer}/v1`

  oktaAuth = new OktaAuth({
    issuer: `${appConfig.oktaOrgUrl}/oauth2/${appConfig.authorizationServer}`,
    clientId: appConfig.clientId,
    redirectUri: `${window.location.origin}${import.meta.env.VITE_PUBLIC_PATH}/implicit/callback`,
    postLogoutRedirectUri: `${window.location.origin}${import.meta.env.VITE_PUBLIC_PATH}`,
    scopes: oktaConfig.scopes,
    pkce: true,
    authorizeUrl: `${customAuthUrl}/authorize`,
    userinfoUrl: `${customAuthUrl}/userinfo`,
    logoutUrl: `${customAuthUrl}/logout`,
    tokenManager: {
      storageKey: oktaConfig.storageKeys.MY_MACHINE
    },
    restoreOriginalUri: async (_oktaAuth, originalUri) => {
      router.replace(
        toRelativeUrl(originalUri || '/', window.location.origin)
      )
    },
    transformAuthState: async (_oktaAuth, authState) => {
      if (authState.isAuthenticated && authState.idToken && (authState.idToken as any).clientId) {
        authState.isAuthenticated = (authState.idToken as any).clientId === appConfig.clientId
      }
      return authState
    }
  })
}

function decodeTokenPayload(token: string): any {
  const payloadBase64 = token.split('.')[1]
  if (!payloadBase64) return null

  const base64 = payloadBase64.replace(/-/g, '+').replace(/_/g, '/')
  const padded = base64 + '='.repeat((4 - base64.length % 4) % 4)

  return JSON.parse(atob(padded))
}

export async function refreshAccessTokenIfExpiringSoon(minTimeLeftMs = 90000): Promise<void> {
  const auth = oktaAuth as any
  const token = auth?.getAccessToken?.()

  if (typeof token !== 'string' || token.length === 0) {
    return
  }

  try {
    const payload = decodeTokenPayload(token)

    if (payload?.exp) {
      const expirationMs = payload.exp * 1000
      const timeLeftMs = expirationMs - Date.now()

      if (timeLeftMs < minTimeLeftMs) {
        await auth?.tokenManager?.renew?.('accessToken')
      }
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Access token expiration time: unable to parse token')
  }
}


export default oktaAuth
